import { RED_400, RED_600, GREEN_400, GREEN_600, YELLOW_400, YELLOW_600 } from '../colors';
var healthConfig = {
  type: 'success',
  size: 'md',
  theme: 'light',
  config: {
    iconSize: {
      sm: 24,
      md: 28,
      lg: 32
    },
    healthStylesType: {
      warning: {
        color1: YELLOW_400,
        color2: YELLOW_400
      },
      success: {
        color1: GREEN_400,
        color2: GREEN_400
      },
      danger: {
        color1: RED_400,
        color2: RED_400
      }
    }
  }
};
var darkHealthConfig = Object.assign(Object.assign({}, healthConfig), {
  theme: 'dark',
  config: Object.assign(Object.assign({}, healthConfig.config), {
    healthStylesType: {
      warning: {
        color1: YELLOW_600,
        color2: YELLOW_600
      },
      success: {
        color1: GREEN_600,
        color2: GREEN_600
      },
      danger: {
        color1: RED_600,
        color2: RED_600
      }
    }
  })
});
var whiteHealthConfig = Object.assign({}, healthConfig);
export default {
  light: healthConfig,
  dark: darkHealthConfig,
  white: whiteHealthConfig
};